module.exports = "<router-outlet></router-outlet>\n<div *ngIf=\"showLoadingFile\">\n  <app-loading-file></app-loading-file>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main